// DO NOT EXPORT THIS FILE
// use getConfig instead

const config = {
  host: {
    bus: 'https://api-trip.txt.staging-traveloka.com',
    hcn: 'https://hcnpapi.hcn.staging-traveloka.com',
  },
  isCognitoEnabled: true,
  amplify: {
    Auth: {
      region: 'ap-southeast-1',
      userPoolId: 'ap-southeast-1_dyaf2O6OG',
      userPoolWebClientId: '2fav9s4316uv200hp31168vsee',

      oauth: {
        domain: 'https://txt-stg.auth.ap-southeast-1.amazoncognito.com/',
        scope: ['email', 'profile', 'openid'],
        redirectSignIn: 'http://localhost:3000/',
        redirectSignOut: 'http://localhost:3000/',
        responseType: 'code',
      },
    },
  },
  auth: {
    domain: 'tvlk-dev.auth0.com',
    clientID: 'Cts3M2Cv564dBpJIUyCMaZSGAVOQD6ND',
    redirectUri: '/callback',
    audience: 'https://tvlk/txt',
    responseType: 'token id_token',
    scope: 'openid',
  },
};

export default config;
